export interface BrandList {
    id?: number;
    brand_name?: string;
    color_code?: string;
    status?: 1 | 0;
    user_id?: number | null;
}

// to single object maping
export const mapBrandList = (data:any): BrandList => {
    if(!data){
        throw new Error('Invalid Data')
    }
    const  res: BrandList ={
        id: data.id,
        brand_name: data.brand_name,
        color_code: data.color_code,
        status: data.status,
        user_id: data.user_id,
    }
    return res;
}

// maping list objects
export const mapBrandLists = (data:any[]): BrandList[] => {
     if (!Array.isArray(data)) {
       throw new Error('Invalid Data');
     }
     return data.map(mapBrandList);
}